import { createAction, props } from '@ngrx/store';

import { UserInDetail } from '../users.interface';
import { Answer, Question } from '../../questions/questions.interface';
import { Investment } from '../../investments/investments.interface';
import { Analysis } from '../../analyses/analyses.interface';
import { Subscription } from '../../subscriptions/subscriptions.interface';
import { KYC } from 'src/app/core/interfaces/shared.interface';
import { InvestmentCompany } from '../../investment-companies/investment-companies.interface';
import { CreateIndividualManualPepCheck, IndividualPEP } from '../../pep-list/pep-list.interface';

export const setUser = createAction('[User Component] Set User', props<{ user: UserInDetail }>());

export const changeCustomerStatus = createAction(
  '[User Component] Change Customer Status',
  props<{
    id: string;
    customerStatus: UserInDetail['customer_status'];
    customerStatusExplanation?: UserInDetail['customer_status_explanation'];
  }>()
);

export const switchEdition = createAction('[User Component] Switch Edition');

export const setUserInvestments = createAction('[User Component] Set User Investments', props<{ investments: Investment[] }>());

export const setUserKYC = createAction('[User Component] Set User KYC', props<{ kyc: KYC[] }>());

export const setUserQuestions = createAction('[User Component] Set User Questions', props<{ questions: Question[] }>());

export const setUserAnalyses = createAction('[User Component] Set User Analyses', props<{ analyses: Analysis[] }>());

export const setUserSubscriptions = createAction('[User Component] Set User Subscriptions', props<{ subscriptions: Subscription[] }>());

export const setUserInvestmentCompanies = createAction(
  '[User Component] Set User Investment Companies',
  props<{ investmentCompanies: InvestmentCompany[] }>()
);

export const updateUserSubscription = createAction('[User Component] Update User Subscription', props<{ subscription: Subscription }>());

export const updateUserAnswer = createAction('[User Component] Update User Answer', props<{ id: string; answer: Answer }>());

export const updateUserAnalysisStatus = createAction('[User Component] Update User Analysis Status', props<{ analysis: Analysis }>());

export const toggleUserAnalysisStatus = createAction('[User Component] Toggle User Analysis Status', props<{ analysisId: string }>());

export const updateUserQuestionStatus = createAction('[User Component] Update User Question Status', props<{ question: Question }>());

export const setUserPepChecks = createAction('[User Component] Set user pep checks', props<{ pepChecks: IndividualPEP[] }>());

export const deleteFile = createAction('[User Component] Delete File', props<{ id: string }>());

export const resetUserState = createAction('[User Component] Reset User State');

// Requests

export const loadUser = createAction('[Api/Request User] Load User', props<{ id: string }>());

export const loadUserKYC = createAction('[Api/Request User] Load User KYC', props<{ id: string }>());

export const loadUserSubscriptions = createAction('[Api/Request User] Load User Subscriptions', props<{ id: string }>());

export const loadUserQuestions = createAction('[Api/Request User] Load User Questions', props<{ id: string }>());

export const loadUserAnalyses = createAction('[Api/Request User] Load User Analyses', props<{ id: string }>());

export const loadUserInvestmentCompanies = createAction('[Api/Request User] Load User Investment Companies', props<{ id: string }>());

export const changeUserSubscriptionStatus = createAction('[Api/Request User] Change User Subscription Status', props<{ id: string }>());

export const changeUserAnswer = createAction(
  '[Api/Request User] Change User Answer',
  props<{ id: string; answer: string; userId: string }>()
);

export const changeUserAnalysisStatus = createAction('[Api/Request User] Change User Analysis Status', props<{ id: string }>());

export const changeUserQuestionStatus = createAction('[Api/Request User] Change User Question Status', props<{ id: string }>());

export const loadUserPepChecks = createAction('[Api/Request User] Load User Pep Checks', props<{ id: string }>());

export const createUserManualPep = createAction('[Api/Request User] Create user manual PEP', props<CreateIndividualManualPepCheck>());
